import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useFetchData from "../../../../../hooks/useFetchData";
import { DEFAULT_WELL_COMPLETION_STATE } from "../constants";
import { useStateIfMounted } from "use-state-if-mounted";

export const useWellCompletion = (selectedWell) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_WELL_COMPLETION_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty && name !== "driller_add_new") setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;

      if (name === "driller_add_new" && value) {
        newFilterValues["driller_ndx"] = null;
      }

      if (name === "driller_add_new" && value === false) {
        newFilterValues["temp_new_driller"] = null;
        newFilterValues["driller_ndx"] = data?.driller_ndx ?? null;
      }

      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWell) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_WELL_COMPLETION_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-wells-completion", selectedWell],
    async () => {
      if (!selectedWell) {
        setIsDirty(false);
        setEditorState(DEFAULT_WELL_COMPLETION_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-wells-completion/${selectedWell}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [drillerLookup] = useFetchData("ui-list-wm-driller", [], true);

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      driller: drillerLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
